import React from 'react';

import { FlexColumnBlock } from '../styled';
import { Typography, useMediaQuery } from 'fronton-react';
import { InfoBar } from 'common/components';
import { WarningCircleIcon } from '@fronton/icons-react';
import { css } from 'linaria';

export const infoBarStyles = css`
	width: 100%;
	max-width: 854px;
	margin-top: 0;
`;

export const SmallRequest = () => {
	const isMobile = useMediaQuery('(max-width: 767px)');

	return (
		<FlexColumnBlock>
			<Typography size="subtitle" variant={isMobile ? 'm' : 'l'}>
				Небольшая просьба
			</Typography>
			<Typography size="body_short" variant={isMobile ? 'm' : 'l'}>
				Очистите инструмент перед визитом — так нам будет проще и приятнее с ним работать
			</Typography>
			<InfoBar
				className={infoBarStyles}
				type="warning"
				icon={<WarningCircleIcon type="outline" size="l" color="text-primary" />}
				title="Важно: инструменты с ГСМ (горюче-смазочными материалами)"
				paragraph="Из соображений безопасности мы не можем принимать инструменты, в которых есть топливо, масло или другие жидкости. Пожалуйста, полностью слейте все ГСМ перед сдачей"
			/>
		</FlexColumnBlock>
	);
};
